import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../store'
import { Mode } from '../../../../../models/enums'

type MobileDisplayResultProps = {
  onClick: () => void
}

const MobileDisplayResult = ({ onClick }: MobileDisplayResultProps): JSX.Element => {
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)

  return (
    <div className={`rf-w-full rf-pt-8 ${mode === Mode.text ? 'rf-mb-30' : 'rf-mb-16'} rf-flex rf-justify-center rf-justify-self-end`}>
      <button className='rf-py-4 rf-px-6 rf-font-bold rf-text-secondary rf-border-2 rf-rounded-lg rf-border-secondary' onClick={onClick}>
        {translation.template.showresults}
      </button>
    </div>
  )
}

export default MobileDisplayResult
